export const PROJECTS_PAGE = "projectsPage";
export const SOURCES_PAGE = "sourcesPage";
export const USE_CASES_PAGE = "useCasesPage";
export const TRIAL_PORTAL_HOME = "/cloudshell/resources/trial.html";
